import { Component, EventEmitter, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';
import { LanguageServiceService } from '../../../services/language-service.service';
@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrl: './welcome.component.scss'
})
export class WelcomeComponent implements OnInit, OnDestroy {
  @Output() close = new EventEmitter<boolean>();
  showPopup:boolean = false;
  currentLanguage!: string | null;

  lang = [
    { code: 'en', name: 'English' },
    { code: 'ar', name: 'arabic' },
  ];
  constructor(private _router:Router,
    private translate: TranslateService,
    private _languageService: LanguageServiceService,
    private render: Renderer2
  ){}
  ngOnDestroy(): void {
    this.render.removeStyle(document.body, 'overflow');
  }
  ngOnInit(): void {
    this.render.setStyle(document.body, 'overflow' , 'hidden');
  }

  openPopup(){
    this.showPopup = true;
  }
  toggleLanguage() {
    this.currentLanguage = this.currentLanguage === 'en' ? 'ar' : 'en';
    this.translate.use(this.currentLanguage);
    localStorage.setItem('language', this.currentLanguage);
    console.log(this.currentLanguage);
    this._languageService.toggleLanguage();
    if (this.currentLanguage == 'ar') {
    }
  }
  closePopup(){
    this.close.emit(false);
  }
  skipToHome() {
    this.closePopup();
    // this.router.navigate(['/home']); // Adjust the route if necessary
  }
  goToSelect(){
    this.closePopup();
    this._router.navigateByUrl('select-page');
  }
}
